module.exports = __webpack_public_path__ + "static/media/Panzares.79718820.jpg";